import initIssuesAnalytics from 'ee/issues_analytics';

initIssuesAnalytics();
